export const START_FETCH_CUSTOM_ORDERS = 'START_FETCH_CUSTOM_ORDERS';
export const FETCHED_CUSTOM_ORDERS = 'FETCHED_CUSTOM_ORDERS';
export const FETCH_CUSTOM_ORDERS_ERROR = 'FETCH_CUSTOM_ORDERS_ERROR';
export const UPDATE_PAGE_NUMBER = 'UPDATE_PAGE_NUMBER';
export const STORE_ALL_CUSTOM_ORDERS = 'STORE_ALL_CUSTOM_ORDERS';
export const SHOW_FILTER_DATA = 'SHOW_FILTER_DATA';
